import { fetcher } from '@commenda/utils';
import { FileRecord } from './types';

export async function getFileRecordForCustomerSubmission(
  submissionId: string,
  clerkToken?: string
): Promise<{
  success: boolean;
  data?: FileRecord;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `portal/customer/submissions/${submissionId}/file-record`,
      {
        method: 'GET',
      },
      undefined,
      clerkToken
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to get file record',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function getFileRecordForSellerSubmission(
  sellerId: number,
  submissionId: string
): Promise<{
  success: boolean;
  data?: FileRecord;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `portal/sellers/${sellerId}/submissions/${submissionId}/file-record`,
      {
        method: 'GET',
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to get file record',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

